export default __webpack_public_path__ + "static/media/chiclayo-street_sunset.7493c436.jpg";